'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.monthsBefore;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/monthsBefore.js
// module id = 721
// module chunks = 0